import React from 'react';
import { useTrustyActor, useTrustyState } from '../TrustyProvider';
import { trustyConstants as c } from '../../lib/trusty.constants';
import { Odometer, HoldButton } from '../../../../shared/ui';
import { gameConfig } from '../../lib/trusty.config';
import css from './TrustyUI.module.css';

export const UIContent = () => {
    const { send } = useTrustyActor();
    const state = useTrustyState();
    const [canChoice, setCanChoice] = React.useState(false);
    
    // Стан для анімованих значень (починаємо з 0)
    const [animatedScores, setAnimatedScores] = React.useState({
        score: 0,
        set1Score: 0,
        set2Score: 0,
        highScore: 0
    });

    const { score, set1Score, set2Score, highScore } = state.context;

    const isSet1Ready = state.matches(c.states.set1Ready);
    const isSet2Ready = state.matches(c.states.set2Ready);
    const isIntermediate = state.matches(c.states.intermediateStats);
    const isGameOver = state.matches(c.states.gameOver);

    React.useEffect(() => {
        setCanChoice(false);
        const timer = setTimeout(() => setCanChoice(true), 1200);
        return () => clearTimeout(timer);
    }, [state.value]);

    // Ефект для запуску анімації одометра
    React.useEffect(() => {
        if (isGameOver || isIntermediate) {
            // Спочатку скидаємо в 0
            setAnimatedScores({ score: 0, set1Score: 0, set2Score: 0, highScore: 0 });
            
            // Через невелику паузу встановлюємо фінальні значення, що запустить прокрутку
            const timer = setTimeout(() => {
                setAnimatedScores({
                    score: state.context.score,
                    set1Score: state.context.set1Score,
                    set2Score: state.context.set2Score,
                    highScore: state.context.highScore
                });
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [isGameOver, isIntermediate, score, set1Score, set2Score, highScore]);

    if (isSet1Ready) {
        return (
            <div className={css.gameOverInfo}>
                <h2>Оберіть напрям для Сету 1</h2>
                <div className={css.choiceContainer}>
                    <HoldButton 
                        onAction={() => canChoice && send({ 
                            type: c.events.START, 
                            languages: { 
                                set1: gameConfig.languages.set1, 
                                set2: gameConfig.languages.set2 
                            } 
                        })} 
                        className={`${css.choiceBtn} ${!canChoice ? css.disabled : ""}`}
                        disabled={!canChoice}
                    >
                        EN ➔ UA
                    </HoldButton>
                    <HoldButton 
                        onAction={() => canChoice && send({ 
                            type: c.events.START, 
                            languages: { 
                                set1: gameConfig.languages.set2, 
                                set2: gameConfig.languages.set1 
                            } 
                        })} 
                        className={`${css.choiceBtn} ${!canChoice ? css.disabled : ""}`}
                        disabled={!canChoice}
                    >
                        UA ➔ EN
                    </HoldButton>
                </div>
            </div>
        );
    }

    if (isSet2Ready) {
        const direction = state.context.set2Langs.q.startsWith('en') ? "EN ➔ UA" : "UA ➔ EN";
        return (
            <div className={css.gameOverInfo}>
                <div className={css.direction}>{direction}</div>
            </div>
        );
    }

    if (isIntermediate) {
        const direction = state.context.set1Langs.q.startsWith('en') ? "EN ➔ UA" : "UA ➔ EN";
        return (
            <div className={css.gameOverInfo}>
                <h2>{direction} завершено!</h2>
                <div className={css.stats}>
                    <div className={css.statRow}>
                        <span>Результат:</span>
                        <Odometer number={animatedScores.set1Score} />
                    </div>
                </div>
            </div>
        );
    }

    if (isGameOver) {
        const set1Label = state.context.set1Langs.q.startsWith('en') ? "EN ➔ UA" : "UA ➔ EN";
        const set2Label = state.context.set2Langs.q.startsWith('en') ? "EN ➔ UA" : "UA ➔ EN";
        
        return (
            <div className={css.gameOverInfo}>
                <h2>Гра закінчена!</h2>
                <div className={css.stats}>
                    <div className={css.statRow}>
                        <span>{set1Label}:</span>
                        <Odometer number={animatedScores.set1Score} />
                    </div>
                    <div className={css.statRow}>
                        <span>{set2Label}:</span>
                        <Odometer number={animatedScores.set2Score} />
                    </div>
                    <div className={css.statRow} style={{fontWeight: 'bold', borderTop: '2px solid var(--border-color)'}}>
                        <span>Середній бал:</span>
                        <Odometer number={animatedScores.score} />
                    </div>
                    <div className={css.statRow}>
                        <span>Рекорд:</span>
                        <Odometer number={animatedScores.highScore} />
                    </div>
                </div>
                {score > highScore && <div className={css.newRecord}>НОВИЙ РЕКОРД!</div>}
            </div>
        );
    }
    return null;
};
